import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { ApplicationStore } from "Types/state";
import { isLockedPricingSetup } from "src/store/selectors/account";
import CloseButton from "src/components/CustomizePayment/LockedPricingSnackBar/CloseButton";
import styled from "styled-components";
import "./LockedPricingSnackBar.scss";

const Sentiment = styled("span")`
    background-color: ${(props) => props.theme.palette.primary.main};
    height: auto;
    flex: 0 0 4px;
`;

const LockedPricingSnackBar = ({ accountHasLockedPricing }: ReturnType<typeof mapLockedPricingStateToProps>) => {
    const location = useLocation<{ fromUnlock?: boolean }>();
    const { t } = useTranslation();
    const [mounted, setMounted] = useState(accountHasLockedPricing && !!location.state?.fromUnlock);

    return (
        <>
            {mounted && (
                <div className={"locked-pricing-snackbar-container close"}>
                    <Sentiment className={"locked-pricing-snackbar-sentiment"} />
                    <header className={"locked-pricing-snackbar-header"}>
                        {t("CustomizePayment.LockedPricing.snackBar")}
                    </header>
                    <CloseButton onClick={() => setMounted(!mounted)} />
                </div>
            )}
        </>
    );
};
const mapLockedPricingStateToProps = (state: ApplicationStore) => ({
    accountHasLockedPricing: isLockedPricingSetup(state),
});

export default connect(mapLockedPricingStateToProps)(LockedPricingSnackBar);
